import React from "react";
import { ArrowButton } from "../../components/arrow-button";

interface HidayetGunesiProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}

const JackieJackson = (props: HidayetGunesiProps) => {
    return (
        <div style={{ display: props.isVisible ? "block" : "none" }}>
            <article>
                <ArrowButton onClick={props.comeBackSemaSection} />
                <h4 className="section-title">JACKIE JACKSON <br /> MESİH CEMAL CEM <br />(Amerikalı Rahip)</h4>

                <p className="sub-title">
                    Cemal Cem’in İslam’la buluşma öyküsünü
                    kendisinden dinleyelim:
                </p>
                <p>
                    Hristiyan anne ve Yahudi bir babanın evladı olarak
                    Amerika’da dünyaya geldim. İki yaşımda iken ailem tarafından
                    vaftiz edildim. Ailemin beni çok küçük yaşta
                    kilise okullarına göndermesiyle Hıristiyanlık eğitimi
                    almaya başladım. Yedi yaşına bastığımda diğer çocuklardan
                    farklı olduğumu düşünen ailem için bir gurur
                    kaynağı idim. Çünkü daha o yaşta, kilisedeki ayinlerde
                    papaza, Hz. İsa’nın kanı ve eti diye kabul edilen şarap
                    ve ekmeğin sunuluşunda yardım ediyordum. Bu da
                    aileme büyük bir övünç veriyor ve babamı geleceğim
                    konusunda güzel düşüncelere sevk ediyorlardı.Genç
                    yaşta kilise büyükleri tarafından misyoner vaiz olarak
                    görevlendirildim.
                </p>
                <p>
                    Tevrat ve İncil üzerine araştırmalarım oldu. Annem
                    gibi Hıristiyanlığı seçtim. Bunda vicdanî bir kanaatten
                    çok Hıristiyanlığın ülkemdeki yaygınlığı etkili oldu.
                    Her iki kitapta da aradığımı bulamadım. Tevrat’taki
                    uzun hikâyelerle, İncillerdeki çelişkiler bana itici gel192
                    di. Üstelik İnciller kâinat ve hayatın tam bir izahını ve
                    dünya işlerini düzenleyen herhangi bir yön içermiyorlardı.
                    Zaten sonraları ben de bu kitapların peygamberlere
                    gönderildiği gibi olmadığını öğrenecektim.
                </p>

                <p>
                    Uzun süre insanları Hıristiyanlığa davetle meşgul
                    oldum. İslam’ı ise hiç inceleyememiştim. Güçlü ve etkin
                    kilise propagandası İslam’ı geri kalmışların dini
                    olarak ve daha bunun gibi sayısız iftira ve karalamalarla
                    sunmaya yetiyordu. Bu yüzden İslam’a düşman olarak
                    yetiştirildim. Üstelik kilise, bana her türlü lüks ve
                    konforu vaat ediyordu. Bu gibi nedenlerle kısa sürede
                    ünlü bir vaiz oldum. Afrika ülkeleri ve Güney Amerika
                    da dahil olmak üzere çeşitli ülkelere misyonerlik faaliyetlerini
                    gerçekleştirmek üzere seyahatlerde bulunuyordum.
                    Çok coşkulu vaazlar yapıyordum. Çevremdeki
                    cemaat git gide büyümüştü. İnsanların sevgisini ve
                    takdirini kazanmıştım. Hatta öyle ki beni o dönem
                    Amerikan başkanlığına aday göstermek isteyenlerin
                    sayısı git gide çoğalıyordu.
                </p>

                <p>
                    Bense kaderin benim için neler gizlediğini merakla
                    bekliyordum. Yıllarca şaşkınlık içinde yaşadım. Var
                    gücümle kiliseye hizmet ediyordum. 19 yıl nefsim ile
                    mücadele ettim. Onun tuzağından bir türlü kurtulamadım.
                    Bu süreç içerisinde yüksek kademelere kadar
                    ulaştım. Hıristiyan inancının sayılı öncülerinden birisi
                    oldum. Washington Üniversitesi'nde Teoloji hocalığı
                    yaptım. O arada Harvard Üniversitesi'nde doktora
                    yapmaya başladım. Doktora çalışmalarım iyi geçti.
                    Harvard'da bana iyi çalışmalar sundular. Bu çalışmala193
                    rımla misyonerlik ve ilahiyat bölümlerinde profesör oldum.
                    iki ay sonra misyonerlik hizmeti için Harvard'da
                    din ve misyonerlik fakültesinde misyonerlik bölüm
                    başkan yardımcılığı verdiler.
                </p>
                <p>
                    Her sene iki yüz kişi mezun oluyordu. Amerika'dan
                    piskoposlar gelir, değişik bölgelere misyonerlik faaliyeti
                    için mezunların çoğunu götürürlerdi. Bu da beni
                    Hıristiyanlığa hizmet ve misyonerlik alanında büyük
                    sorumluluklar yüklenmeye sevk etmişti.
                    Ben de bu arada Hristiyanlık ve misyonerlik üzerine
                    vaaz yapıyordum. Kendime göre çok etkili vaazlar
                    yapıyordum.
                </p>

                <p>
                    Hıristiyan cemaatin ileri gelenleri, ’<span className="text-bold">Jackie Jakson</span>,
                    senin kadar etkili vaaz yapan bir rahip son dönemde
                    görmedik.’ diyorlardı. Bu söylemler doğrusu nefsimi
                    şımartıyordu. Meslektaşım olan piskoposlar da aynı
                    şeyleri konuşuyorlardı.
                </p>
                <p>
                    New York’daki en büyük katedralde vaaz yapmak
                    için yola çıktım. Elimde günah çıkarma asam ve göğsümde
                    altından kardinal madalyasıyla ağır ağır yürüyordum.
                    Bir anda sokaklarda protesto sesleri duyulmaya
                    başladı. Çünkü orda da 200 çocuk Hristiyan din
                    adamları tarafından cinsel istismara uğramıştı. Bu ağır
                    ithamın altında vaaz kürsüsüne çıktım ve biraz vaaz
                    yaptım. Günah çıkarma merasimi yapmadım. Kimseye
                    bir şey söylemeden kilisenin arka kapısından ayrıldım.
                </p>

                <p>
                    Amerika’daki kiliselerde yaygın olarak görülen çocuk
                    istismarı başta olmak üzere Hıristiyan din adamlarının
                    ahlaksızlıkları karşısında kendimden geçmiştim.
                    Odama kapanmış, dışarı çıkmak dahi istemiyordum.
                    Vatikan’daki Papa, kiliselerde çocuk istismarının
                    olduğunu, bunun çok çirkin bir şey olduğunu ve bu
                    olaylar karşısında artık ne yapacaklarını, ne söyleyeceklerini
                    dahi bilemediklerini açıklaması üzerine çok
                    etkilenmiştim. Artık Amerika’daki kiliselere girmek
                    dahi istemiyordum.
                </p>

                <p>
                    Bir yıl sonra, davet edildiğim İngiltere’de aynı hastalık
                    devam ediyordu. Papa medyada konu ile ilgili
                    açıklama yapıyordu. Kiliseler çocuk istismarını kaldıramazlardı.
                    Bu durum din adamları için ahlaksızlık ve
                    çok çirkin bir durum olarak değerlendiriliyordu.
                </p>
                <p>
                    3 ay sonra İrlanda’da büyük bir kilisede vaaz için
                    davetliydim. Orada kilisenin lojmanında kaldım. Sabah
                    kalktığımda yine elimde günah çıkarma asam ve göğsümde
                    250 gram ağırlığında altından kardinal madalyasıyla
                    ağır ağır yürüyordum.
                    Yine protestolar devam ediyordu. Çünkü orada 500
                    çocuk kilisenin din adamaları tarafından cinsel istismara
                    uğramış. Çocukların yakınları, anneleri, babaları,
                    halk kiliseye karşı çok öfkeliydi. Çaresiz kalmışlar kilisenin
                    arka kapısından içeriye girdim içerideki cemaat
                    ayağa kalktı ve oradaki din adamlarını protesto etmeye
                    başladılar. Bir din adamı için çok ağır bir ithamdı bu.
                </p>

                <p>
                    Kürsüye çıktım başımı ellerimin arasına aldım çok
                    derin düşündüm empati yaptım. İşin içinden bir türlü
                    çıkamıyordum. Piskoposa ve büyük kardinallere benim
                    burada vaaz yapmayacağımı söyledim. Onlar da benim
                    için ‘<span className="text-bold">Jackie</span> Jackson bizi hayal kırıklığına uğrattın’
                    dediler.
                </p>

                <p>
                    Bunun üzerine hac yapmak amacıyla Kudüs’e gittim.
                    Beytüllahim’deki <span className="text-bold">Hz. İsa’nın</span> Doğuş Kilisesine
                    yaptığım ziyarette eski dostum Kudüs’lü Keşiş Leon
                    Tomas’la karşılaştık. Onunla geçirdiğim bir hafta boyunca
                    dinler üzerine derin konuşmalarımız oldu.
                    Tevrat, İncil ve Kur’ân’dan bahsettik. Bana İstanbul’a
                    gitmemi tavsiye etti.
                </p>

                <p>
                    Böylelikle İstanbul’a geldim. Bir otele yerleştim. Bir
                    gün çevredeki etkinlikleri sorduğumda bana bir broşür
                    verdiler ve Mevlevi Ayin-i Şerifi olduğunu söylediler.
                    İstanbul’daki Galata Mevlevihane’sinde Sema ayini izledim.
                    Ertesi gün “İstanbul’da başka yerde etkinlik yapılıyor
                    mu?” diye sorduğumda arkadaşlar <span className="text-bold">Fatih’teki
                        Hz. Mevlanâ’nın Kurmuş Olduğu Uluslararası
                        Sema Okulu Derneğinden </span> söz ettiler.
                    Burada her hafta sema ayini olduğunu ve orijinal
                    semayı burada görebileceğimi söylediler.
                </p>

                <p>
                    <span className="text-bold">
                        Hz. Mevlana’nın: “Gel, gel… Ne olursan ol
                        yine gel. Yüz bin defa tövbeni bozmuş olsan da
                        yine gel… Bizim dergâhımız ümitsizlik dergâhı
                        değildir.”&nbsp;
                    </span>
                    çağrısı bana ulaşmış ve hidayet nuru kendini
                    göstermişti. Sanki içimden bir sesin beni kendine çağırdığını hissediyordum.
                </p>

                <p>
                    2014 yılı Nisan ayı idi. Bir önceki günün heyecanından
                    otelde uyuyamamıştım. Kaldığım otelde ezan
                    sesini duydum. Müezzin efendi üç makamlı bir ezan
                    okudu. Musikiye aşina olduğum için içimde müthiş bir
                    heyecan oluştu. Duyduğum ezan sesi beni adeta kendisine
                    çağırıyordu. Hemen resepsiyona haber verdim.
                    “Bu ses hangi camiden geliyor” diye sordum.
                    <span className="text-bold">Fatih Camisi'nden&nbsp;</span>
                    geliyor dediler. ”Beni o camiye gönderir
                    misiniz” dedim. Onlar da ‘Peki’ dediler.
                    Ben camiye hazırlanırken yanımdaki danışmanlarım
                    bana sordular:
                </p>

                <p>
                    “Peder, bu heyecanla nereye gitmek istiyorsun?”
                    dediler.Ben de “Camiye gideceğim” dedim. “Hayrola?”
                    dediler. “Müslümanların ibadet şeklini yerinde görmek
                    istiyorum” dedim.
                    <span className="text-bold">&nbsp;Fatih Camiisine </span> girdim. Öyle heybetli muazzam
                    bir mabed ki kendimi tutamadım. Hemen yanımdaki
                    fotoğraf makinemi çıkardım. Bana imam odasının
                    önünde bir yer gösterdiler. Resim çekmek için görevlilerden
                    izin istedim. Onlar da bana izin verdiler.
                </p>

                <p>
                    Böyle büyük bir camide mükemmel bir akustik vardı.
                    Öyle mükemmel bir ışıklandırma yapmışlardı ki caminin
                    her tarafından âdeta Allah’ın nuru fışkırıyordu.
                    Kiliselerdeki uyutulmuş loş ışıklar yoktu. Böyle güzel
                    bir mabedi görünce içimdeki heyecanım arttı. Ne kadar
                    da mükemmel bir mabed yapmışlar. Hayretler içinde
                    kaldım.” Camideki görevlilere sordum.”Beni bilgilendirecek
                    birisi var mı?” dedim.
                    O sırada kapıdan üç kişi girdi. <span className="text-bold">‘Ali Yakub Babacan </span>
                    geldi ve size yardımcı olur.’ dediler. Ben de teşekkür
                    ettim. Baba ile orada ilk tanıştık.
                </p>

                <p>
                    Baba'ya sordum; ''bu ezanlar beş vakit minarelerden
                    okunur mu?''
                    Baba; ''Bunun ismi Ezan-ı Muhammediyedir. Buna
                    Davet-i Muhammedi de denir. Çünkü dünya döndüğü
                    sürece insanları yirmi dört saat kesintisiz olarak
                    Allah'ın huzuruna çağırır.''
                    Babaya sordum:
                    ''Caminin özellikleri hakkında beni bilgilendirir
                    misiniz? Caminin kaç kapısı var? Bu kapı sayılarının
                    bir manası var mı?''
                    Baba cevap verdi:
                </p>

                <p>
                    ‘‘Hem de çok önemli manaları vardır. Caminin beş
                    kapısı vardır. Bir de padişahımızın girdiği altıncı kapı
                    vardır. Bu imanın altı şartını temsil eder.
                    Caminin cemaatin girdiği beş kapısı İslam’ın beş
                    temel şartını temsil ediyor. Dışarda son cemaat mahalindeki
                    üç tane şadırvanın kapısını de sayarsak bu
                    da cennetin sekiz kapısını temsil eder. İşte bu Sultan
                    Fatih’in mimarî dehasıdır ki imanın ve islamın şartlarını
                    remzedecek ve cennetin sekiz kapısını temsil eden
                    bir eser bırakmıştır.
                </p>

                <p>
                    Müezzinlerin bulunduğu müezzin mahfili vardır.
                    Müslümanların bayramı olan Cuma günü, Hatip efendi
                    dünya ve ahiret mevzularında cemaati bilgilendirmek
                    için minberde hutbeye çıkar. Bir Şeyh kürsüsü vardır.
                    Kürsü Şeyhi halka günlük vaazlar yapar. İmam Efendi
                    mihrapta namaz kıldırır. Bir de Kâbe'nin içindeki zemzem
                    kuyusunu temsil eden bir kuyu vardır. Görmüş olduğun
                    kuyu da budur. Halk ondan abdest alır, su içer.
                </p>

                <p>
                    Babaya tekrar sordum:
                    “Sabah namazı kaç rekattır?”
                    Baba cevap verdi:
                    — Sabah namazı dört rekattır.İki şahitli bir namazdır.(
                    İsra Suresi 78.ayet). İkisi sünnet ikisi farzdır.
                    Şimdi ilk olarak kılınacak olan iki rekat; Sahib-i şeriat
                    olan <span className="text-bold">Hz Muhammed (S.A.V) </span>’in iki rekat sünnetidir,”
                    diye buyurdu.
                </p>
                <p>
                    Caminin beş kapısından giren cemaat hür iradeleri
                    ile istedikleri yerde huşu içerisinde ikişer rekat namaz
                    kılıp, Allah’a zikir ,tesbih ve tenzih eyliyorlardı ve
                    Allah’a hamd edip Kur’an okuyorlardı.
                    Baba; iki rekat sünnetin Allah’a şükür ve peygamberine
                    teşekkür mahiyetinde olduğunu söyledi ve devam
                    etti.
                </p>

                <p>
                    — Allah biz kullarını sabah namazına camiye davet
                    buyurduğu için Allah’a hamd ve şükür secdesinde
                    bulunuyorlar. Namaz müminin miracı, cami miracın
                    mahalidir. Camide Miracın sırrı gerçekleşir ve mümin
                    namazla birlikte Rabbine doğru yücelir. Nasıl ki Allah
                    el-Câmi adıyla insanı birliğe çağırıyorsa, cami de insanı
                    Allah’ın güzel isimlerinin gölgesine çağırır. Gelin beş
                    vakitte O’na biatımızı tazeleyelim. Sizler de tevhit inancına
                    davetlisiniz.
                </p>

                <p>
                    <span className="text-bold">Hz. Mevlana’nın ‘Kim halis niyetle ararsa
                        aradığını bulur.’</span> cümlesine binaen siz de bu yolun
                    gidilip gidilemeyeceğini denemeye davetlisiniz. Halis
                    niyetle birlikte bilgi, teslimiyet ve icraatın yanında sohbet
                    de öğrenmenin diğer bir sütunudur. Bu islam okulu
                    insana, ego zırhından nasıl kurtulacağını ve güneşin
                    ardındaki güneşi nasıl arayacağını göstermektedir.
                    Bizim amacımız, kapalı kalpleri islam için fışkırır hale
                    getirmektir. Bunun için tüm gücümüzü bu işe veriyoruz.
                    Ancak ne yaşadıysak ,muvazeneli ve doğruya sadık
                    kalarak aktarıyoruz.’’
                </p>

                <p>
                    O sırada sabah namazının farzı kılınmadan evvel
                    müezzin efendi Ümmeti Muhammedin sağlık ve sıhhati
                    için gülbank-ı Muhammediye duasını okudu.
                    O sırada sabah namazının farzı kılınmadan evvel
                    Müezzin efendi, Müezzin mahfilinde güzel sesiyle
                    Kur’an-ı Kerim kıraatinde bulundu.
                    Baba’ya sordum:
                    “Okunan Kuran-ı Kerim’in anlamı nedir?”
                    Baba cevap verdi:
                </p>
                <p>
                    ‘‘Allah-u Teâlâ tarafından Miraç Gecesi
                    <span className="text-bold">Hz. Muhammed (S.A.V)</span> ve ümmetine üç hediye
                    ile gönderilmiştir. Bu okunan ayeti kerime, Miraç hediyelerden
                    birisi olan Sure-i Bakara’nın son iki ayetidir.
                    <span className="text-bold"> Bakara Sûresinin 285 - 286.</span> ayet-i kerimelerdir.
                    Aracısız olarak geldi.
                    Allah-u Teâlâ, biz kullarının güçlü bir imana sahip
                    olmamız için yatsı namazına müteakiben ve sabah namazı
                    farzından önce okunmasını irade buyurmuşlar.
                    Ayetin Meal-i Şerif şöyledir:
                    “Peygamber, Rabbi tarafından kendisine indirilene
                    iman etti, müminler de (iman ettiler). Her biri Allah’a,
                    meleklerine, kitaplarına, peygamberlerine iman ettiler.
                    ‘Allah’ın peygamberlerinden hiçbiri arasında ayırım
                    yapmayız. İşittik, itaat ettik. Ey Rabbimiz, affına sığındık!
                    Dönüş sanadır’ dediler.
                </p>

                <p>
                    Allah her şahsı, ancak gücünün yettiği ölçüde mükellef
                    kılar. Herkesin kazandığı (hayır) kendine, yapacağı
                    (şer) de kendinedir. Rabbimiz! Unutursak veya
                    hataya düşersek bizi sorumlu tutma. Ey Rabbimiz!
                    Bizden öncekilere yüklediğin gibi bize de ağır bir yük
                    yükleme. Ey Rabbimiz! Bize gücümüzün yetmediği işler
                    de yükleme! Bizi affet! Bizi bağışla! Bize acı! Sen bizim
                    Mevlâmızsın. Kâfirler topluluğuna karşı bize yardım et!”
                </p>

                <p>
                    Tekrar sordum:
                    “Okunan <span className="text-bold">üç İhlas-ı Şerifin</span> anlamı nedir?”
                    Baba da cevap verdi: “Papaz Efendi isabetli bir soru
                    sordunuz. Ben de sizin böyle bir soru sormanızı bekliyordum
                    doğrusu.”
                    <span className="text-bold">“ Üç İhlas-ı Şerîf müezzinlerin Vird-i Şerifidir.</span>
                    ve her camide namazdan önce üç İhlas-ı Şerîf okunur,
                    sonunda ise müezzzin efendi tarafından Fatiha çekilir.
                    Bütün cemaat tarafından <span className="text-bold">Fatiha-i Şerif</span> tilavet olunur.
                    <span className="text-bold"> Üç İhlas, Fatiha-i Şerif sülüs-ü Kur’an</span> olduğu
                    rivayet buyurulmuştur. Ki sabah namazının farzından
                    önceki bölüm budur.’’
                </p>

                <p>
                    Baba:‘‘Ey papaz efendi! <span className="text-bold">Hz. Muhammed (S.A.V)</span>’in bir hadisini söyleyeyim mi?
                    <span className="text-bold">Hz. Muhammed (S.A.V)</span> buyuruyor ki:
                    ‘‘Atam <span className="text-bold">Hz. İbrahim Halilullah’ın</span> duası, kardeşim
                    <span className="text-bold"> Hz. İsa Ruhullah’ın</span> müjdesi olan gökte Ahmed,
                    yerde Muhammed’im.’’
                    <span className="text-bold">Hz. Muhammed (S.A.V)</span> Hristiyanların sordukları
                    soruya -teslis inancına- İhlas-ı Şerif ile cevap
                    vermiştir.

                    <span className="text-bold">“Allah 'Ahad'dir, Allah 'Samed' dir. Allah
                        doğmamış ve doğurmamıştır.” </span>
                    <span className="text-bold">Üç-bir, Bir-üçtür</span> inancına cevap olaraktan camilerde
                    <span className="text-bold"> üç İhlas-ı Şerifin</span> okunmasına Müçtehidler tarafından
                    irade buyurulmuştur.
                </p>

                <p>
                    Rahip, Baba'ya sordu:"İmam efendi namazda hangi
                    sureyi okuyor?
                    Baba cevap verdi:
                    "Günde beş vakit namazda kırk defa her rekkatta
                    birer defa Fatihatü'l Kitap veya Fatihatü'l Dua olarak
                    kıraat olunur. Kur'andan kısa surelerden ya da birkaç
                    ayeti-i kerime okuyarak namazı tamamlar."
                    "Allah-ı Azimüşşan sizin duanız olmazsa neye yararsınız
                    diye soruyor. Dua beş vakit namazda kıraat
                    olunan Fatihatü'l Kitap, Fatihatü'l Dua dır."
                    Bu arada müezzin efendi çok güzel makamlı bir kamet
                    getirmeye başladı. Müslümanlar hür iradeleriyle
                    mihrabdaki imam efendinin arkasında iki rekat sabah
                    namazının farzını kılmak için başlarında beyaz takkeleriyle
                    saf saf olup, Allah-u Ekber nidasıyla namaza
                    başladılar. İmam efendi ,Hangi vakit ise o vaktin niyetini
                    alır.Euzu besmele çeker,Fatihatü'l Kur'an veya
                    Fatihatü'l Dua kıraat okur. Onu müteakip Kur'andan
                    kısa surelerden ya da birkaç ayeti-i kerime okuyarak
                    namazı tamamlar.
                </p>

                <p>
                    Bir komutla yüzlerce insan Allah’ın huzuruna kıyama
                    durdu. Bu manzara bana çok etkileyici gelmişti.
                    Babaya döndüm ve ‘‘Ne kadar etkileyici bir manzara!
                    Bu her gün böyle midir?” diye sordum
                    Baba cevap verdi:
                    ‘‘Evet. Her gün, beş vakit Allah'ın huzurunda bu cemaati
                    böyle kıyamda görebilirsiniz.’’
                    Müslümanların uyum içinde kıldıkları namazı huşu
                    içerisinde izledim. Derken selam verdiler. sonrasında
                    Baba namazdan sonraki ritüeli anlatmaya başladı.
                    “Namazın farzına müteakiben <span className="text-bold">Ayetel Kürsi</span>, cemaat
                    tarafından kıraat olunur. Sonra <span className="text-bold">Allah’ın doksan
                        dokuz İsm-i Şerifi</span> tesbih edilir. Sonra cemaat
                    olarak Allah’ın dergah-ı bargâh-ı ilahisine ellerini açan
                    Müslümanlar, boyunlarını bükmüş vaziyette dua makamında
                    bulunurlar. Allah, boynu büküklerin dualarını
                    reddetmeyeceğini vaad ediyor.
                    Bir de sabah namazının farzına müteakiben okunan
                    Kur’an’ı Kerimler vardır. Hepsinin anlamları da
                    farklıdır.”
                </p>

                <p>
                    Namaza müteakiben davudi bir sesle imam efendi
                    Kur’an’daki <span className="text-bold">Sure-i Haşir</span>’den ayet-i kerimeler kıraat
                    etmeye başladı. Caminin akustiğinin mükemmelliği ile
                    birleşen imam efendinin makamlı Kur’an tilaveti, beni
                    yerimden hoplattı. Ayağa kalktım. O esnada bir kaç kişi
                    ‘Allah’ diye bağırdı.
                    <span className="text-bold">Sure-i Haşir</span> kıraat olunduktan sonra kürsünün
                    önünde güzel sesli bir Hafız Kur’an okumaya başladı.
                </p>

                <p>
                    Baba’ya tekrar sordum:
                    “Bu okunan Kur’anı Kerim nedir?”
                    Baba,<span className="text-bold">‘Fetih Suresi’</span> diye buyurdular.
                    <span className="text-bold"> Fetih suresi</span> okunurken 19 yıl önce Washington’da
                    sahilde deniz kenarında kordon boyunda gezerken
                    <span className="text-bold">‘Jackie Jakson</span> kendini tanı!’ diye kulağıma gelen sesleri,
                    Allah bana hatırlattı. Aynı sesleri tekrar hissettim.
                    <span className="text-bold"> Baba: ‘‘Fetih suresinin</span>, vaiz kürsüsünün önünde
                    haftanın beş günü sabah namazından sonra okunması,
                    <span className="text-bold"> Fatih Sultan’ın</span> vakfiyesi olarak buyurulmuş.
                    Caminin güzel sesli müezzin efendileri tarafından kıraat
                    olunur. Haftanın iki günü Cuma ve Pazartesi sabah
                    namazına müteakip <span className="text-bold">İmam efendi</span> tarafından
                    <span className="text-bold"> Yasin-i Şerif</span> okunur.’’ dedi.
                </p>

                <p>
                    “Muhammed Allah’ın elçisidir. Onunla beraber
                    olan mü’minler, kafirlere karşı çok şiddetli, kendi aralarında
                    ise çok merhametlidirler. Onları rükua varırken,
                    secde ederken görürsün. Onlar, Allah’tan lutüf ve
                    rıza isterler. Onların nişanları yüzlerindeki secde izidir.
                    Bu, onların Tevrat’taki vasıflarıdır. İncil’deki vasıfları
                    da şöyledir: Onlar filizini yarıp çıkarmış, gittikçe onu
                    kuvvetlendirerek kalınlaşmış, gövdesi üzerine dikilmiş
                    bir ekine benzerler ki bu, ekicilerin de hoşuna gider.
                    Allah böylece onları çoğaltıp kuvvetlendirmekle kâfirleri
                    öfkelendirir. Allah onlardan inanıp iyi işler yapanlara
                    mağfiret ve büyük mükâfat vaad etmiştir.”(Sure-i
                    Fetih 29. ayeti kerime)
                </p>

                <p>
                    <span className="text-bold">Fetih suresinin 29. ayet-i kerimesinde
                        Tevrat ve İncil'den</span> bahsedildiğini duyar duymaz,
                    ‘Allah’ diye bir sayha attım. Bu durum karşısında dehşete
                    kapılmıştım.
                </p>

                <p>
                    <span className="text-bold">Baba</span>, ‘‘Ey Papaz Efendi! Kur’an-ı Kerim’de <span className="text-bold">Tevrat
                        ve İncil</span>'den bahseden onlarca ayet-i kerime bulabilirsiniz.
                    Lütfedip bakarsanız, bu ayetler müslüman olmanızı
                    kolaylaştırır.
                    <span className="text-bold">“Ey papaz efendi! Allah’ın Kur’an’ı Kerim’de
                        belirttiğine göre Hz. Musa’yı da Hz. İsa’yı da biz
                        sizden daha çok seviyoruz.</span> Bunu hatırlarsan senin
                    için hayırlı olur.
                    Bu ayetlerin <span className="text-bold">İncil ve Tevrat</span>’ta bulunup bulunmadığına
                    otele gidip bilgisayarımda bakacağımı söyledim.
                    Ertesi gün <span className="text-bold">Baba</span>’yı ziyarete zaviyeye gittim.
                    Baba’ya, <span className="text-bold">Tevrat ve İncil</span>’de bu ayetleri bulamadığımı,
                    Tevrat ve İncil’in gerçek manasının
                    tahrif edildiğini şimdi daha çok anladığımı söyledim.
                    ‘‘Ne secdemiz var ne namazımız var” dedim.
                    <span className="text-bold"> Baba dedi ki:</span>
                </p>

                <p>
                    “Ey Papaz efendi! On dört yıl önce Kudüs’e gitmiştim.
                    <span className="text-bold"> Hz Davud(A.S)</span> ‘ın doğduğu evi ziyarete
                    gitmiştim. Hristiyanlar orayı keşişhane yapmışlardı.
                    Baktım içerde namaz kılan keşişler var. Demek ki
                    Hristiyanlık'ta namaz varmış. Şimdi size soruyorum.
                    Keşişler namaz kılıyorlar, siz de <span className="text-bold">Hz. İsa(A.S)</span>’ı temsil
                    ettiğinize göre namaz kılıyor musunuz?”
                    ‘‘Hayır” dedim. ‘‘Onlar Hıristiyan sofulardır.”
                    Baba, “Peki siz niçin kılmıyorsunuz?” dedi:
                    “Çünkü kilisenin anayasasına koymamışlar.” dedim.
                    <span className="text-bold"> Ey Papaz Efendi!</span> Kiliselerdeki ayinlerde Hz.
                    İsa'nın kanı olarak bilinen şarap ikram ediliyor ve Hz.
                    İsa'nın eti olarak ekmek ikram ediliyor. Bu nasıl bir din
                    ve imandır ki insan sevdiğinin kanını içip etini yiyebilir?
                    Doğrusu İnsanın aklı ve mantığı almıyor.
                    <span className="text-bold"> Papaz Efendi</span> dedi ki; kilisenin anayasasına koymuşlar
                    ne çare! Söylediğiniz gibi aynen uygulanıyor.
                    <span className="text-bold"> Baba’ya</span> “Bu kadar derin sorularla karşılaşacağımı
                    hiç düşünmemiştim. Yıllarca misyonerlik yaptım.
                    Herkesin sorusunu rahatlıkla cevaplamıştım. Ama sizin
                    sorunuza cevap vermekte hayli zorlanıyorum.” dedim.
                    <span className="text-bold"> Baba</span>: ”Bu konuştuğumuz mevzuları yarın ahirette
                    Allah sana da bana da soracak.”diye buyurdu.
                </p>

                <p>
                    Babaya dönerek ''Size bir şey itiraf etmek isterim.
                    Vazifem münasebeti ile ne havralarda ne sinagoglarda
                    ne kiliselerde ne de budist tapınaklarında insanları
                    Allah'a yaklaştıracak özellikler göremedim. Çin'e
                    Japonya'ya ve Hindistana gittim, uzak doğu ülke
                    lerindeki budist tapınaklarına ziyaretim olmuştur.
                    Bu tapınaklarda aynı kilise ve havralardaki gibi ibadetlerin
                    hiç bir özelliği kalmamış. Buralarda ibadetlerde
                    Allah'la kul arasına hep birileri girmiş. Sizinle birlikte
                    Fatih Camisinde müslümanların ibadet şekillerini izledim.
                    İslam dışında Allah'a ve peygambere yaklaştıran
                    orjinal bir din tasavvur edemiyorum doğrusu.'' dedim.
                    Baba yine sordu:
                </p>

                <p>
                    —Cami ve kilise arasındaki farkı görebildiniz mi?”
                    —Cami ile kilise arasındaki büyük farkı gördüm ki
                    ne kilisedeki zenginlerin fakirlerden ayrı oturduğu koltuklar
                    var, ne org ne de musiki aletleri var.
                    Büyük kiliselerin her köşesinde günah çıkarma odaları
                    ve ikna odaları var.
                    Çocukların vaftiz yapıldığı su kuyusu var.
                    <span className="text-bold"> Hz. İsa’nın </span>kanı olarak bilinen şarap için küpler var. Aynı
                    zamanda <span className="text-bold">Hz. İsa’nın</span> eti olarak bilinen ekmeklerin
                    muhafaza edildiği altın yaldızlarla kaplı dolaplar var.
                    Meydanda papaz efendinin günah çıkardığı büyük kürsü
                    var. Günahı çıkarılan kişinin günahının derecesine
                    göre papazdan 9 santimetre, 18 santimetre ve 40 santimetre
                    aşağıda ayakta durduğu yerler var. Âdet olarak,
                    papaz efendi, günah çıkarma asasını günahı çıkarılmak
                    istenen kişinin başına ve yüzüne paralel kaldırarak
                    günahını bağışlatır. Ancak, bu uygulama her kilisede
                    bulunmuyor.
                    Nedense kilise, tahmin edilemeyecek kadar loş ve
                    uyutulmuş ışıklar ile bezenmiş.
                    Cami gibi sade değil. Çok pahalı altın ve
                    bronzdan yapılmış avizeler ve şamdamlar var.
                </p>

                <p>
                    Camide ise bunların hiçbiri yok. Cami huşu içerisinde
                    ibadet yapılacak çok sade bir mabed...
                    Aslında konuşacağımız çok mevzu var, ama burada
                    fazla kelam konuşmaya gerek yok’’ dedim.
                    Ertesi akşam zaviyede tekrar buluşmak için
                    sözleştik.
                </p>

                <p>
                    Akşam arkadaşlarımla buluşup zaviyeye geldik,
                    burada sema ayinini izledik. Semazenlerin duruşları,
                    birbirlerine olan tavır ve nezaketleri beni çok etkilemişti.
                    <span className="text-bold"> Liderleriyle</span> görüşüp bazı sorularımın olduğunu
                    ilettim. Rüyalarımı anlattım. Onlar da beni anlayışla
                    karşıladılar. ‘‘İnanç üzerine sorular sorabilir
                    miyim?’’ dedim. O da bana ‘‘Bildiğimiz sorular olursa
                    cevaplandırırız. bilemediğimiz cevapları da en yakın
                    zamanda sana ulaştırırız.’’ dedi. Baba’nın bu yaklaşımı,
                    ‘‘Bildiğimiz olursa cevaplarız’’ deyişi çok güven vericiydi.
                    Kendilerine sonsuz teşekkürlerimi sundum. ‘‘Bu
                    cevapla beni çok sevindirdiniz.’’ dedim.
                    Bu sohbet sonucunda Efendi “Biz sana inancımızı
                    takdim edelim,” dedi ve bana iman esaslarını tek tek
                    açıkladı. Amentü’yü okumaya başladı.
                </p>

                <p>
                    <span className="text-bold">“Amentü billahi ve melâiketihi,ve kütübihî
                        ve rusülihî ve’l yevmi’l-âhıri ve bi’l-kaderi, hayrihî
                        ve şerrihi mina’llâhi teâlâ ve’l-ba’sü ba’de’l
                        mevt. Hakkun, Eşhedü en lâ ilâhe illallâh ve eşhedü
                        enne Muhammeden abdühû ve rasûlühü.”
                    </span>
                </p>

                <p>
                    <span className="text-bold">Baba</span> bana, “imanın şartlarını lisan ile söyler,kalben
                    tasdik edersem müslüman olacağımı “söyledi.
                    “İçindeki Allah’ın iman enerjisini hissedersen inşallah
                    İslâm’la müşerref olursun” dedi. Ben de onunla
                    birlikte tekrar etmeye başladım.
                </p>

                <p>
                    <span className="text-bold">İslam'ın esasları: (Kelime-i Şahadet, Namaz,
                        Oruç, Zekât, Hac) talim buyruldu.</span>
                </p>

                <p>
                    Benim içimde sanki hicran ırmakları çağlamaya
                    başlamıştı. Bu duygular içerisinde  <span className="text-bold">“Eşhedü en la ilahe
                        illallah ve eşhedü enne Muhammeden abdühû
                        ve Resûlüh”</span> diyerek Müslüman oldum. Şehadet
                    getirirken içimi öyle bir hüzün kaplamıştı ki ağlamamak
                    için kendimi zor tutuyordum. Elimde olmadan
                    gür bir sesle İslam’ı kabul ettiğimi söyledim. Huzurda
                    bulunan semazen arkadaşlar da salavatlar okuyarak ve
                    beni tek tek tebrik ettiler. İslam kardeşliğimiz hayırlı
                    olsun dediler.
                </p>

                <p>
                    Bana <span className="text-bold">Cemal Cem</span> ismini verdiler.
                </p>

                <p>
                    Beş gün sonra çok mutlu bir şekilde İstanbul’dan
                    ayrıldım. Hayatımın en verimli günlerini burada
                    yaşamıştım…
                    Amerika’ya döndüm. İçimde sakinlik ve sessizlik
                    hissediyordum. Kiliselere gidiyorum ancak
                    içimden gelmediği için vaizlik yapmıyordum.
                    Görevli kardinal arkadaşlar “<span className="text-bold">Jackie Jackson </span>çok sessiz
                    duruyorsun bir şeyler mi var yoksa? Fırtına öncesi
                    sessizlik gibi bu halin.” diyorlardı. ‘‘Hayır, her şey çok
                    güzel.’’diyordum.
                    Ben de istifa edip İslam ile müşerref olduğumu ilan
                    etmek için uygun zamanı kolluyordum. Altı ay sonra
                    üzerimdeki kilisenin parası olan 465.000 doları yatırdım,
                    hemen ertesi gün istifamı sundum ve Müslüman
                    olduğumu söyledim.
                </p>

                <p>
                    Hiç vakit kaybetmeden kilisede bir heyet kuruldu ve
                    beni soruşturmaya aldılar. Baş rahipler ellerinde asalarıyla
                    beni dürtüyorlardı.
                    Ağır ithamlarda bulunuyorlar, “Sen ne zaman aklını
                    kaybettin, delirdin?” diye soruyorlardı. Hemen psikologlara
                    benim için bir deli raporu hazırlattılar.
                    Ertesi gün evime baskın yaptılar, kütüphanedeki
                    bütün kitaplarımı götürdüler. Güney Amerika’daki
                    kuzenimin yanına gittim, bir ay sonra beni orada da
                    buldular, rahat bırakmadılar. Oradan da ayrılmak zorunda
                    kaldım. Altı ay sonra iş yapmak için Arjantin’e
                    gittim. Orada üç arkadaş daha Müslüman oldu. Fakat
                    bir ay sonra orada da beni rahatsız ettiler.
                </p>

                <p>
                    Onu müteakiben İngiltere'deki kuzenim davet etmişti.
                    Biliyorum ki ingiliz istihbaratı tersine çalışır. Benim
                    yüzümden ona rahatsızlık verirler diye gidemedim.
                    Üç ay sonra Brezilya’nın San Paula şehrinde büyük
                    bir at çiftliği olan eski bir arkadaşımın yanına yerleştim.
                    Burada bize bir mescid tahsis ettiler ve her gün
                    ibadetlerimizi yapmaya başladık. Bu arada Müslüman
                    olanların sayısı on kişiye ulaştı. Bunların arasında
                    Yahudi Haham başı yardımcısı, Amerika ve Güney
                    Afrika kıtasında çok önemli vaizler ve Hıristiyanlardan
                    çok önemli kardinaller vardı.
                </p>

                <p>
                    Artık her gün güzel sesli hafızların sesinden Kur’an-ı
                    Kerim dinliyoruz. Ney, kûdüm ve bendir eşliğinde tasavvuf
                    müziği dinlemeye de başladık.
                    Bu gün burada olmaktan mutluyum, bir sıkıntı yaşamıyorum.
                    İslam’ı yaşamaya ve yaşatmaya çalışıyorum.
                    Eski dindaşlarımın da İslam ile müşerref olabilmesi
                    için gece gündüz dua ediyorum.
                    Allah cümlemize hidayet etsin.
                    Şunu söyleyebilirim ki içimde büyük bir heyecan ve
                    enerji var. Adeta yerimde duramıyorum. Devamlı birşeyler
                    yapmak istiyorum. Allah hayırlara çıkarsın.
                </p>

                <p>
                    <span className="text-bold">Sevgili Ali Yakub Baba</span>, duanızı bekliyorum.
                </p>

            </article>
        </div >
    );
}

export default JackieJackson;